export default __webpack_public_path__ + "static/media/home.0712c6dd.jpg";